import { PACKAGES } from '../../lib/constants';

const PER_MONTH = '/ month';
const PER_USER_PER_MONTH = '/ user / month';
const BILLED_ANNUALLY = 'Starting at 3 users, billed annually';
type PER_MONTH_ANNUALLY = (price: string) => string | null;
const getPerMonthAnnually: PER_MONTH_ANNUALLY = price => `${price} billed annually`;

type PackageDef = {
  [key: string]: Package;
};

type Package = {
  priceUnit?: string;
  byline?: string;
  pricePerMonthAnnually?: PER_MONTH_ANNUALLY;
  highlighted?: boolean;
};

const PackageDefs: PackageDef = {
  [PACKAGES.TeamAdvantage]: {
    priceUnit: PER_USER_PER_MONTH,
    byline: BILLED_ANNUALLY,
  },
  [PACKAGES.TeamPremier]: {
    priceUnit: PER_USER_PER_MONTH,
    byline: BILLED_ANNUALLY,
  },
  [PACKAGES.Enterprise]: {
    byline: 'Powerful admin tools, integrations, and collaboration features for your organization.',
  },
  [PACKAGES.PremierAnnual]: {
    priceUnit: PER_MONTH,
    pricePerMonthAnnually: (price: string) => getPerMonthAnnually(price),
  },
  [PACKAGES.AdvantageAnnual]: {
    priceUnit: PER_MONTH,
    pricePerMonthAnnually: (price: string) => getPerMonthAnnually(price),
    highlighted: true,
  },
  [PACKAGES.StandardMonthly]: {
    priceUnit: PER_MONTH,
    pricePerMonthAnnually: () => null,
  },
};

export default PackageDefs;
